import { render, staticRenderFns } from "./ViewTicketModal.vue?vue&type=template&id=f0fb5280"
import script from "./ViewTicketModal.vue?vue&type=script&lang=js"
export * from "./ViewTicketModal.vue?vue&type=script&lang=js"
import style0 from "./ViewTicketModal.vue?vue&type=style&index=0&id=f0fb5280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports